// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MindFilledGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.092 18.186a1.38 1.38 0 0 1-.711-.197c-.521-.317-5.066-3.184-5.466-6.957l-.004-.023a3.192 3.192 0 0 1-.037-.449V10.502c0-.07.005-.139.015-.207a3.785 3.785 0 0 1 3.782-3.532 3.79 3.79 0 0 1 2.42.863 3.786 3.786 0 0 1 2.42-.863 3.786 3.786 0 0 1 3.783 3.542c.009.065.014.13.014.196v.06c0 .164-.018.317-.037.453l-.006.045c-.396 3.75-4.942 6.614-5.459 6.928-.216.13-.462.2-.714.2Zm.098 25.21c-.663 0-.946-.246-1.118-.394-1.187-1.028-1.476-3.242-1.756-5.383-.107-.814-.26-1.989-.444-2.49-.734-.023-1.484.046-2.27.117-1.247.112-2.534.225-3.869-.007a4.432 4.432 0 0 1-2.751-1.141c-.976-.817-1.556-2.992-2.064-7.726l-.016-.144c-.139-.065-.31-.125-.479-.185-.714-.251-2.2-.774-2.01-2.685.003-.037.01-.075.016-.11.189-.915.922-1.813 1.698-2.765.454-.556 1.299-1.59 1.31-1.955-.037-1.292.036-6.627.04-6.853 0-6.86 6.437-9.564 6.93-9.76 5.23-2.25 17.725-2.94 23.08 9.268 4.763 10.861-2.176 18.646-4.176 20.582l.102.43c.527 2.227.877 3.698-.436 4.676-7.295 5.428-10.386 6.525-11.787 6.525Z"
			fill="url(#MindFilledGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="MindFilledGradient_tsx__a"
				x1={0.396}
				y1={0.604}
				x2={35}
				y2={43}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75E0AC" />
				<stop offset={1} stopColor="#76BEDE" />
			</linearGradient>
		</defs>
	</svg>
);
export default MindFilledGradient;
